import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { parseAsDateUTC, toISODatewithoutTimezone } from 'app/infrastructure/data/date';
import { ExternalUrlGroupsItemWire, AccessPolicyWire, ExternalUrlWire } from '../types';
import { ExternalUrlGroupItem, AccessPolicyValue, ExternalUrlItem } from 'app/area/external-url-groups/form/types-store';

export const mapExternalUrlGroupFromWire = (wire: Partial<ExternalUrlGroupsItemWire>): ExternalUrlGroupItem => ({
  id: wire?.code?.v,
  description: wire?.code?.d,
  disabled: wire?.disabled
    ? parseAsDateUTC(wire?.disabled)
    : undefined,
  sequence: wire?.sequence,
  language: (wire?.language?.map(codeItemToStoreValue) ?? [])
    .map(item => ({
      value: item.value,
      description: item.description
    })),
  longDescription: (wire?.language?.map(codeItemToStoreValue) ?? [])
    .map(item => ({
      value: item.value,
      description: item.longDescription
    })),

  accessPolicy: accessPolicyToStoreValue(wire?.accessPolicy),
  externalUrls: externalUrlToStoreValue(wire?.externalUrl)
});

export const mapExternalUrlGroupToWire = (externalUrlGroup: ExternalUrlGroupItem): ExternalUrlGroupsItemWire => ({
    code: { v: externalUrlGroup?.id, d: externalUrlGroup?.description },
    sequence: externalUrlGroup?.sequence,
    disabled: externalUrlGroup?.disabled
      ? toISODatewithoutTimezone(externalUrlGroup?.disabled)()
      : undefined,
    language: externalUrlGroup?.language?.map(languageItem => {
      const longDescription = externalUrlGroup?.longDescription?.find(longDescriptionItem =>
        longDescriptionItem.value === languageItem.value)?.description?.trim();

      return {
        v: languageItem.value,
        d: languageItem.description?.trim(),
        ...(!!longDescription && { ld: longDescription })
      };
    }) ?? [],
    accessPolicy: mapAccessPoliciesToWire(externalUrlGroup?.accessPolicy),
    externalUrl: mapExternalUrlToWire(externalUrlGroup?.externalUrls)
  });

export const accessPolicyToStoreValue = (accessPolicies: AccessPolicyWire[]): AccessPolicyValue[] =>
  accessPolicies ? accessPolicies?.map((accessPolicy, index) => ({
    id: index + 1,
    operation: codeItemToStoreValue(accessPolicy?.operation),
    caseType: codeItemToStoreValue(accessPolicy?.caseType)
  })) : [];

export const mapAccessPoliciesToWire = (accessPolicies: AccessPolicyValue[]): AccessPolicyWire[] =>
  accessPolicies?.map(accessPolicy => ({
    operation: { v: accessPolicy.operation.value, d: accessPolicy.operation.description },
    caseType: { v: accessPolicy.caseType.value, d: accessPolicy.caseType.description }
  })
  ) ?? [];

export const externalUrlToStoreValue = (externalUrls: ExternalUrlWire[]): ExternalUrlItem[] =>
  externalUrls ? externalUrls?.map((externalUrl) => ({
    code: codeItemToStoreValue(externalUrl.code),
    disabled: externalUrl?.disabled
      ? parseAsDateUTC(externalUrl?.disabled)
      : undefined,
    sequence: externalUrl.sequence,
    urlTemplate: externalUrl.urlTemplate
  })) : [];

const mapExternalUrlToWire = (externalUrls: ExternalUrlItem[]): ExternalUrlWire[] => {
  return externalUrls
    ?.map(externalUrl => ({
      code: {
        v: externalUrl.code?.value,
        d: externalUrl.code?.description,
        ld: externalUrl.code?.longDescription,
        disabled: externalUrl.code?.disabled
      },
      sequence: externalUrl.sequence,
      disabled: externalUrl?.disabled
        ? toISODatewithoutTimezone(externalUrl.disabled)()
        : undefined,
      urlTemplate: externalUrl.urlTemplate
    })) ?? [];
};
